<script>
	// Partials
	import GroupUpdate from '@/Partials/Sport/Markets/Groups/_Update.svelte';
	import GroupSetUpdate from '@/Partials/Sport/Markets/GroupSets/_Update.svelte';
	// Services
	import { getUrlParameter } from '@/Services/Helpers';

	export let action;
	export let id;

	const actionMap = {
		groups: GroupUpdate,
		'group-sets': GroupSetUpdate
	};

	$: sportId = parseInt(getUrlParameter('sport')) || false;
</script>

<!-- ACTION UPDATE COMPONENT -->
<svelte:component this={actionMap[action]} {id} {sportId} />
